import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { compact } from 'lodash'

import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { Table } from 'components/UI'
import { Format } from 'services/Dates'
import { TrackAction } from 'services/TrackAction'
import { removeShiftsToConfirm } from 'store/actions/applicationInfo'
import { closeModal } from 'store/actions/modals'
import { createErrorNotification } from 'store/actions/notifications'
import { destroy, init } from 'store/actions/tables'
import { Card } from 'ui'
import { t } from 'translations'

const EmployeeShiftConfirmationModal = () => {
  const dispatch = useDispatch()
  const { shiftsToConfirm } = useSelector(state => state.applicationInfo)

  const [isSubmitting, setIsSubmitting] = useState()

  useEffect(() => {
    if (!shiftsToConfirm) return

    const header = [
      { key: 'positionName', label: 'employee.shiftConfirmation.POSITION' },
      { key: 'start', label: 'employee.shiftConfirmation.START', type: 'date', outFormat: 'humanDateTime' },
      {
        key: 'end',
        label: 'employee.shiftConfirmation.END',
        type: 'custom',
        render: (end, { isExtraShift }) => (isExtraShift ? null : Format(end, { outFormat: 'humanDateTime' }))
      }
    ]

    init('employee-shift-confirmation', compact(header), null, { content: shiftsToConfirm, count: shiftsToConfirm.length || 0, limit: Infinity })
    return () => destroy('employee-shift-confirmation')
  }, [shiftsToConfirm])

  const confirm = async () => {
    if (!shiftsToConfirm) return
    // Track action in intercom
    TrackAction('CONFIRM_MY_SHIFTS', { amount: shiftsToConfirm.length })

    setIsSubmitting(true)
    const scheduleContactEventIds = shiftsToConfirm.map(shift => shift.scheduleContactEventId)
    const { success } = await Api.put('/schedule/confirm', { scheduleContactEventIds })
    if (!success) return dispatch(createErrorNotification())
    setIsSubmitting()
    dispatch(removeShiftsToConfirm())
    dispatch(closeModal())
  }

  return (
    <BaseModal title="employee.shiftConfirmation" hideButtons noPadding shouldCloseOnOverlayClick={false} preventClosing>
      <Card maxHeight="40rem" className="mx-3 mb-3">
        <Table name="employee-shift-confirmation" />
      </Card>
      <div className="px-3 pb-3">
        <Button className="btn btn-primary mr-2" isSubmitting={isSubmitting} onClick={confirm}>
          {t('employee.shiftConfirmation.PRIMARY_ACTION')}
        </Button>
      </div>
    </BaseModal>
  )
}

export default EmployeeShiftConfirmationModal
